import React from "react";
import axios from "axios";
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
} from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faCreditCard,
  faList,
  faTachometerAlt,
} from "@fortawesome/free-solid-svg-icons";
import { NavLink } from "react-router-dom";
import { API_URL } from "./api";
import LanguageContext from "../context/LanguageContext";

function SiteOrdersNavigation({ onNavigate }) {
  const { t } = React.useContext(LanguageContext);
  const [allowed, setAllowed] =
    React.useState(false);

  React.useEffect(() => {
    let mounted = true;

    const checkAccess = async () => {
      try {
        const tokens = JSON.parse(
          localStorage.getItem(
            "authTokens"
          ) || "null"
        );

        if (!tokens?.access) {
          return;
        }

        await axios.get(
          `${API_URL}/inventory/site-orders/options/`,
          {
            headers: {
              Authorization:
                `Bearer ${tokens.access}`,
            },
          }
        );

        if (mounted) {
          setAllowed(true);
        }
      } catch (error) {
        if (mounted) {
          setAllowed(false);
        }
      }
    };

    checkAccess();

    return () => {
      mounted = false;
    };
  }, []);

  if (!allowed) {
    return null;
  }

  return (
    <Accordion>
      <AccordionSummary
        expandIcon={<ExpandMoreIcon />}
      >
        <FontAwesomeIcon
          icon={faCreditCard}
          style={{ marginRight: "13px" }}
        />
        {t("sidebar.siteOrders")}
      </AccordionSummary>

      <AccordionDetails>
        <NavLink
          exact
          to="/inventory/site-orders"
          className="nav-link"
          activeClassName="active"
          onClick={onNavigate}
        >
          <FontAwesomeIcon
            icon={faList}
            style={{ marginRight: "13px" }}
          />
          {t("sidebar.details")}
        </NavLink>
      </AccordionDetails>

      <AccordionDetails>
        <NavLink
          exact
          to="/inventory/site-orders/new"
          className="nav-link"
          activeClassName="active"
          onClick={onNavigate}
        >
          <FontAwesomeIcon
            icon={faTachometerAlt}
            style={{ marginRight: "13px" }}
          />
          {t("sidebar.addOrder")}
        </NavLink>
      </AccordionDetails>
    </Accordion>
  );
}

export default SiteOrdersNavigation;
